import { handleActions } from 'redux-actions'
import * as type from './type'

export const initialState = {
    taskDefinitionList: [],
    fetching: false,
    error: null,
}


export default handleActions({
    [type.FIND_TASK_DEFINITION_LIST_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.FIND_TASK_DEFINITION_LIST_SUCCESS]: (state, action) => {
        const { taskDefinitionList } = action.payload
        return {
            ...state,
            taskDefinitionList,
            fetching: false,
        }
    },
    [type.FIND_TASK_DEFINITION_LIST_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.CHANGE_TASK_DEFINITION]: (state, action) => {
        const { taskDefinitionId, name, value } = action.payload
        return {
            ...state,
            taskDefinitionList: state.taskDefinitionList.map(taskDefinition => {
                return taskDefinition.id !== taskDefinitionId ? taskDefinition : {
                    ...taskDefinition,
                    [name]: value,
                }
            }),
        }
    },

    [type.SAVE_TASK_DEFINITION_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
        }
    },
    [type.SAVE_TASK_DEFINITION_SUCCESS]: (state, action) => {
        return {
            ...state,
            fetching: false,
        }
    },
    [type.SAVE_TASK_DEFINITION_ERROR]: (state, action) => {
        const { error } = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/process/state/task-definition/reducer.js